import { BlackDot } from '@ui/components/BlackDot';
import { BoxProps } from 'styled-system/jsx';

export const NotificationDot = (p: BoxProps) => {
  const shouldShowNotification = false;
  if (shouldShowNotification) {
    return <BlackDot boxSize="2" bgColor="primary.orange" {...p} />;
  }

  return null;
};
